var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preloader-line"},[_c('div',{staticClass:"preloader-line-box",style:({'max-width': _vm.maxWidth + 'px'})},[_c('div',{staticClass:"slider"})])])}
var staticRenderFns = []

export { render, staticRenderFns }